// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#idea-plan{margin-left:0}#idea-plan .content .masonry{margin-bottom:0;padding-bottom:80px}.masonry .item .el-button--plus-round-xs,.masonry .note .edit-bottom{display:none!important}#idea-plan .content.not-found{min-height:100vh}#idea-plan .content.not-found h1,#idea-plan .content.not-found p{margin:0;padding:0}#idea-plan .content.not-found p{opacity:.5}", ""]);
// Exports
module.exports = exports;
